import gql from 'graphql-tag'

export const UPDATE_PLAYBOOK_SETTINGS_M = gql`
  mutation ScUpdatePlaybookSettings($workspaceId: String!, $minimumDwellTime: Int!) {
    updatePlaybookSettings(workspaceId: $workspaceId, minimumDwellTime: $minimumDwellTime) {
      workspaceId
      minimumDwellTime
    }
  }
`

export const CREATE_CONDITIONAL_CONTENT_M = gql`
  mutation ScMutationCreateConditionalContent($conditionalContentDTO: ConditionalContentDTO!) {
    createConditionalContent(conditionalContentDTO: $conditionalContentDTO) {
      code
      message
      success
      conditionalContent {
        id
      }
    }
  }
`

export const UPDATE_CONDITIONAL_CONTENT_M = gql`
  mutation ScMutationUpdateConditionalContent(
    $id: String!
    $updateConditionalContentDTO: UpdateConditionalContentDTO!
  ) {
    updateConditionalContent(id: $id, updateConditionalContentDTO: $updateConditionalContentDTO) {
      code
      message
      success
      conditionalContent {
        id
        name
        isActive
        workspaceId
        displayIds
        startDate
        endDate
        createdAt
        conditions {
          key
          value {
            vehicleBrand
            vehicleType
            licensePlates
            vehicleListIds
            cameraSourceDeviceIds
            licensePlateStates
            vehicleModels
            vehicleColors
            operator
          }
        }
      }
    }
  }
`

// Batch reorder used by the Active Plays drag-and-drop. One round-trip
// for every touched row, applied atomically on the server — replaces the
// older "N parallel updateConditionalContent" pattern.
export const UPDATE_CONDITIONAL_CONTENT_PRIORITIES_M = gql`
  mutation ScMutationUpdateConditionalContentPriorities(
    $updateConditionalContentPrioritiesDTO: UpdateConditionalContentPrioritiesDTO!
  ) {
    updateConditionalContentPriorities(
      updateConditionalContentPrioritiesDTO: $updateConditionalContentPrioritiesDTO
    ) {
      code
      message
      success
      conditionalContents {
        id
        priority
      }
    }
  }
`

export const COPY_CONDITIONAL_CONTENT_M = gql`
  mutation ScMutationCopyConditionalContent($id: String!) {
    copyConditionalContent(id: $id) {
      code
      message
      success
    }
  }
`

export const DELETE_CONDITIONAL_CONTENT_M = gql`
  mutation ScMutationDeleteConditionalContent($id: String!) {
    deleteConditionalContent(id: $id) {
      code
      message
      success
    }
  }
`
